<template>
  <v-row>
    <v-col cols="12" class="development-overview">
      <v-row>
        <header-block title="Buildings" :content="String(developmentData.counts.buildings)"></header-block>
        <header-block title="Apartments" :content="String(developmentData.counts.apartments)"></header-block>
        <header-block title="Meters" :content="String(developmentData.counts.meters)"></header-block>
        <header-block title="Started Billing" :content="String(developmentData.billing_start)"></header-block>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import {get} from "vuex-pathify";
import HeaderBlock from "@/views/credit-billing/generic/HeaderBlock";


export default {
  name: "CreditBillingSingleHeader",
  computed: {
    developmentData: get('creditBilling/development'),
  },
  components: {
    HeaderBlock
  }
}
</script>

<style lang="scss" scoped>
.development-overview {
  .v-card__subtitle {
    padding-bottom: 0px;
    text-transform: uppercase;
    color: rgba(255,255,255,0.8);
  }
  .v-card__title {
    padding-top: 5px;
    font-size: 1.6rem !important;

    &.smaller {
      font-size: 1.4rem !important;
    }
  }
}

</style>
